// formik components
import { Field } from "formik";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useMemo, useState } from "react";

// Declaring props types for FormField
interface Props {
  label?: string;
  name: string;
  type?: string;
  value: any;
  precision?: number;
  formatted?: boolean;
  disabled?: boolean;
  [key: string]: any;
}

function FormField({
  label,
  name,
  type = "text",
  value,
  precision,
  formatted = true,
  disabled = false,
  ...rest
}: Props): JSX.Element {
  const [isFocused, setIsFocused] = useState(false);

  const displayValue = useMemo(() => {
    if (type === "number" && isFocused) {
      return value;
    }

    if (!isNaN(value) && value !== "" && formatted) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      }).format(value);
    }
    return value;
  }, [value, formatted, precision, isFocused]);

  if (precision > 0) rest.inputProps = { step: Number(`0.${"0".repeat(precision - 1)}1`) };

  return (
    <MDBox mb={1.5}>
      {disabled ? (
        <MDTypography variant="body2" fontWeight="bold" color="text">
          {displayValue}
        </MDTypography>
      ) : (
        <Field
          {...rest}
          type={type === "number" ? "text" : type}
          inputMode={type === "number" ? "decimal" : "text"}
          name={name}
          as={MDInput}
          variant="standard"
          fullWidth
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          value={displayValue}
        />
      )}
    </MDBox>
  );
}

export default FormField;
